import { useMemo } from "react"

import { useMatch } from "react-router-dom"

import { useMapStateContext } from "@l2r-front/l2r-map"

import { useRoadsideStateContext } from "../../../modules/roadside/contexts/RoadsideContext"
import { APP_ROAD } from "../../constants/appRoad"
import { MODULE_ROADSIDE } from "../../constants/modules"
import { RoadContentRouter } from "../../routers/RoadContentRouter"
import { RoadMapRouter } from "../../routers/RoadMapRouter"
import { SidebarRouter } from "../../routers/SidebarRouter"

import * as Styled from "./RoadDesktopLayout.styled"

export function RoadDesktopLayout() {
    const {
        ascendantCodes: roadsideAscendantCodes,
        descendantCodes: roadsideDescendantCodes,
    } = useRoadsideStateContext()

    const matchRoadside = useMatch(`:slugId/${APP_ROAD}/${MODULE_ROADSIDE}/*`)
    const { mapHeightPct } = useMapStateContext()

    const sidebarCount = useMemo(() => {
        if (matchRoadside) {
            const hasAdditionalSidebar = roadsideAscendantCodes.length % 2 === 1 || roadsideDescendantCodes.length > 1
            return Math.floor(roadsideAscendantCodes.length / 2) + (hasAdditionalSidebar ? 1 : 0)
        }

        return 0
    }, [
        roadsideAscendantCodes,
        roadsideDescendantCodes,
        matchRoadside,
    ])

    return (
        <Styled.Wrapper>
            <SidebarRouter />
            <RoadContentRouter />
            <Styled.Map mapHeightPct={mapHeightPct} sidebarCount={sidebarCount}>
                <RoadMapRouter />
            </Styled.Map>
        </Styled.Wrapper>
    )
}
